export const PRODUCTLIST_KEY = 'LOAD_MORE_PRODUCTS';
export const ARTICLELIST_KEY = 'LOAD_MORE_ARTICLES';

export function saveToSessionStorage<T>(key: string, value: T) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // eslint-disable-next-line no-empty
  }
}
export function loadFromSessionStorage<T>(key: string): T | undefined {
  try {
    return JSON.parse(sessionStorage.getItem(key) || '') as T;
  } catch (error) {
    removeFromSessionStorage(key);
    return undefined;
  }
}
export function removeFromSessionStorage(key: string) {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    // eslint-disable-next-line no-empty
  }
}
